// contact pageで使用
export default class ContactPage {
   static getInstance() {
      if (!ContactPage.instance) {
         ContactPage.instance = new ContactPage(); // 初回の呼び出し時にインスタンスを作成
      }
      return ContactPage.instance; // 同じインスタンスを返す
   }

   constructor() {
      document.addEventListener('DOMContentLoaded', () => {
         this.addRequired();
         this.addTypeTel();
         this.apperPlaceholder();
         this.handleContactForm();
      });
      // インスタンスを保存
      ContactPage.instance = this;
   }

   addRequired() {
      document.querySelectorAll('.js-input-required').forEach((element) => {
         element.setAttribute('required', 'required');
      });
   }

   addTypeTel() {
      document.querySelectorAll('.js-input-type-tel').forEach((element) => {
         element.setAttribute('type', 'tel');
      });
   }

   apperPlaceholder() {
      // 全ての入力要素とプレースホルダーを取得
      document.querySelectorAll('.js-input').forEach((inputField) => {
         const placeholderText = inputField.closest('div').querySelector('.js-placeholder');
         if (placeholderText) {
            // 初期状態で非表示
            placeholderText.classList.add('max-h-0');

            // 入力イベントのリスナー
            inputField.addEventListener('input', function() {
               if (inputField.value) {
                  placeholderText.classList.remove('max-h-0');
                  placeholderText.classList.add('max-h-5');
               } else {
                  placeholderText.classList.add('max-h-0');
                  placeholderText.classList.remove('max-h-5');
               }
            });
         }
      });
   }

   // 問い合わせページ読み込み時の初期処理
   // ※mwformで確認ページ完了ページ設定をしていないため、送信後に同一ページにリダイレクトする
   // ※リダイレクト後にエラーがあれば、または完了なら、フォーム内のDOMが書き変わる
   handleContactForm() {
      const formWrapper = document.querySelector('.js-contactPageFormWrapper');
      if (!formWrapper) {
         return;
      }
      const completeForm = formWrapper.querySelector('.mw_wp_form_complete');
      const validatedFormFields = formWrapper.querySelectorAll('.error');
      const sendErrorForm = formWrapper.querySelector('.mw_wp_form_send_error');

      if (completeForm) {
         // 送信完了後だったら
         window.scrollTo({
            top: formWrapper.getBoundingClientRect().top + window.scrollY - document.querySelector('.js-globalNav').offsetHeight,
            behavior: 'smooth'
         });
         document.querySelector('.js-formCompleteNotification').style.display = 'block';
         document.querySelector('.js-formLeadText').style.display = 'none';
      } else if (validatedFormFields.length > 0) {
         // バリデエラーある場合
         window.scrollTo({
            top: formWrapper.getBoundingClientRect().top + window.scrollY - document.querySelector('.js-globalNav').offsetHeight,
            behavior: 'smooth'
         });
         // errorの項目にclass付与してinputフィールドの枠線の色をerrorカラーにする
         validatedFormFields.forEach(field => {
            const formItem = field.closest('.js-form-item');
            if (formItem) {
               formItem.classList.add('hasError');
            }
         });
         document.querySelector('.js-formErrorNotification').style.display = 'block';
      } else if (sendErrorForm) {
         // 何らかの送信エラーがある場合
         window.scrollTo({
            top: formWrapper.getBoundingClientRect().top + window.scrollY - document.querySelector('.js-globalNav').offsetHeight,
            behavior: 'smooth'
         });
         document.querySelector('.js-formSendErrorNotification').style.display = 'block';
      }
   }
};
